function NewsletterPopupControl() {
    if ($.cookie('NewsletterPopup') != "undefined" && $.cookie('NewsletterPopup') != "false") {
        $.ajax({
            type: 'get',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/User/UserCheck",
            success: function (dt) {
                if (dt.USER == -1 && $("#SmallLangCode").val() == "tr") {
                    $("#NewsletterPopup").modal();
                }
            }
        });

    }


    $('#NewsletterPopup').on('hidden.bs.modal', function () {
        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);

        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
        $(".NewsLetterResult").hide();
        $(".NewsletterFormHead").show();
    })


    $("#IgnoreLink > a,.DialogClose").live("click", function () {

        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
        $("#NewsletterPopup").modal("hide");

    });


    $("#newsletterFormSubmit").live("click", function () {
        var expireDate = new Date();
        var minutes = 30;
        expireDate.setTime(expireDate.getTime() + (minutes * 60 * 1000) * 6);
        $.cookie('NewsletterPopup', false, { expires: expireDate, path: '/' });
    });

}

//function HomeCatalogTabs() {


//    $("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4");
//    $("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6");




//    $(".HomeCatalogTabs > ul > li a.TabName").on("click", function () {
//        var ahrefi = $(this).attr("href");
//        var href = $("#MainMenu li a[data-rel='" + $(".HomeCatalogTabs > ul li.active").data("id") + "']").attr("href");
//        var ths = $(this);

//        if (!isMobile(true)) {

//            if (href != undefined && href != null) {
//                document.location.href = href;
//            }

//        }
//        else if (ths.hasClass("active")) {

//            if (href != undefined && href != null) {
//                document.location.href = href;
//            }

//        }
//        else {
//            $(".HomeCatalogTabs > ul > li, #HomeCatalogContens > div").removeClass("active");
//            ths.addClass("active");
//            $("#HomeCatalogContens div".ahrefi).addClass("active");
//        }


//    });

//}

function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }

    });
}

function HeaderFixer() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("header").addClass("fixedHeader");

        }
        else {
            $("header").removeClass("fixedHeader");
        }

    });
}

function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")
    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")
    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }

}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }


                }
            }
            settingTextBanner();
        }
    });


}

function CampaignCountDown(countDownDate) {
    //var countDownDate = new Date("Nov 30, 2019 00:00:00").getTime();

    var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var templateTable = "<table class='countDownTable'><tr class='countDownTableHeader'><td>{d}</td><td>{h}</td><td>{m}</td><td>{s}</td></tr>";
        templateTable += "<tr class='countDownTableBody'><td>Gün</td><td>Saat</td><td>Dakika</td><td>Saniye</td></tr></table>";

        document.getElementById("countDown").innerHTML = templateTable.replace("{d}", days).replace("{h}", hours).replace("{m}", minutes).replace("{s}", seconds);

        if (distance < 0) {
            clearInterval(x);
            document.getElementById("countDown").remove();
        }

    }, 1000);

    //$("#countDown").show();
}

function getAnoncementBanner() {

    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetAnoncementBanner",
        data: "SmallLangCode=" + $("#SmallLangCode").val(),
        success: function (dt) {
            if (dt.length > 0) {

                var desktopCounter = 0;
                var mobileCounter = 0;

                for (var i = 0; i < dt.length; i++) {

                    if (dt[i].BannerShowPlace == 157 && desktopCounter == 0 && $(window).width() > 767) {

                        //$("#AnoncementArea").css("height", "80px").css("max-height", "80px").css("overflow", "hidden").css("background-image", "linear-gradient(rgb(243, 188, 121), rgb(246, 203, 154), rgb(249, 219, 183))");
                        $("#AnoncementArea").css("height", "80px").css("max-height", "80px").css("overflow", "hidden").css("background-color", "#494848");
                        $("#AnoncementArea ul").css("padding", "0");

                        $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><img src='" + dt[i].ImagePath + "' style='height: 80px;overflow: hidden;'></li>");

                        desktopCounter++;

                        $("body").addClass("ActiveAnoncementBanner");
                        $("#AnoncementArea").addClass("ActiveAnoncement");
                    }
                    else if (dt[i].BannerShowPlace == 158 && mobileCounter == 0 && $(window).width() < 768) {

                        //$("#AnoncementArea").css("height", "43px").css("max-height", "43px").css("overflow", "hidden").css("background-image", "linear-gradient(rgb(243, 188, 121), rgb(246, 203, 154), rgb(249, 219, 183))");
                        $("#AnoncementArea").css("height", "43px").css("max-height", "43px").css("overflow", "hidden").css("background-color", "#494848");
                        $("#AnoncementArea ul").css("padding", "0");
                        $("#AnoncementArea ul.mobileSlide").append("<li style='display:block;'><img src='" + dt[i].ImagePath + "' style='height: 43px; width: 100%; overflow: hidden;'></li>");

                        mobileCounter++;

                        $("body").addClass("ActiveAnoncementBanner");
                        $("#AnoncementArea").addClass("ActiveAnoncement");
                    }
                }

                if ($(window).width() > 1200) {
                    CampaignCountDown(new Date("Dec 02, 2019 00:00:00").getTime());
                }
            }
        }
    });

}

function RememberCheck() {
    $(".RememberCheck #cbox").on("change", function () {
        if ($(this).prop("checked")) {
            $(".RememberCheck .customCheck").addClass("checked");
        } else {
            $(".RememberCheck .customCheck").removeClass("checked");
        }
    });
}

function setCookie(cookieName, cookieValue) {

    var expiresDate = new Date();
    expiresDate.setTime(expiresDate.getTime() + (1000 * 60 * 60 * 24));
    $.cookie(cookieName, cookieValue, { path: '/', expires: expiresDate });

}

function getCookie(cookieName) {

    var cookieValue = $.cookie(cookieName);
    return cookieValue;
}

function removeCookie() {

    var isRemoved = $.removeCookie(cookieName);
    if (isRemoved)
        console.log('Cookie ' + cookieName + ' has been removed.');
    else
        console.log('Cookie ' + cookieName + ' not removed.');
}

//$(window).load(function () {
//    $(".UseLazyLoad").Lazy();
//});

$(document).ready(function () {

    //HomeCatalogTabs();
    //GetLayoutTextBanners();
    getAnoncementBanner();
    RememberCheck();

    if ($(window).width() < 767) {
        HometabSlider();
    }

    HomeSuggestedPrdsSlider();

    if ($(window).width() > 992) {
        // NewsletterPopupControl();
    }
    else {
        $("#NewsletterPopup").modal("hide");
    }



    //if ($(".HomeProducts").length > 0) {

    //    //$(".HomeProducts .Prd").addClass("col-sm-8");
    //    //$(".HomeProducts .Prd").addClass("col-xs-12");
    //    $("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4");
    //    $("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6");

    //    $(".HomeProducts div.Prd > a").each(function (index) {

    //        var imgBG = $(this).find("img:first").attr("src");

    //        if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
    //            imgBG = $(this).find("img:first").attr("data-qazy-src");
    //        }

    //        $(this).css("background-image", "url(" + imgBG + ")");
    //        $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

    //    });
    //}


    //if (!isMobile(true)) {

    //    $("#CatalogTabs > li").live({
    //        mouseenter:
    //           function () {

    //               $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //               $(this).addClass("active");



    //               $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

    //           },
    //        mouseleave:
    //           function () {


    //           }
    //    });

    //    if ($("#CatalogTabs li[data-id='173']").length > 0) {

    //        $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //        $("#CatalogTabs > li").removeClass("active");

    //        $("#CatalogTabs li[data-id='173']").addClass("active");
    //        var index = $("#CatalogTabs li[data-id='173']").index();
    //        $("#HomeCatalogContens > div").eq(index).addClass("active");

    //    }


    //}

    //if (!isMobile(true)) {

    //    $("#CatalogTabs > li").live({
    //        mouseenter:
    //           function () {

    //               $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //               $(this).addClass("active");



    //               $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

    //           },
    //        mouseleave:
    //           function () {


    //           }
    //    });

    //    if ($("#CatalogTabs li[data-id='173']").length > 0) {

    //        $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //        $("#CatalogTabs > li").removeClass("active");

    //        $("#CatalogTabs li[data-id='173']").addClass("active");
    //        var index = $("#CatalogTabs li[data-id='173']").index();
    //        $("#HomeCatalogContens > div").eq(index).addClass("active");

    //    }


    //}

    //$("#CatalogTabs li").live("click", function () {
    //    if ($(window).width() > 991) {
    //        var href = $("#MainMenu li a[data-rel='" + $("#CatalogTabs li.active").data("id") + "']").attr("href");


    //        if (!isMobile(true)) {

    //            if (href != undefined && href != null) {
    //                document.location.href = href;
    //            }

    //        } else if ($(this).hasClass("active")) {

    //            if (href != undefined && href != null) {
    //                document.location.href = href;
    //            }

    //        }
    //        else {
    //            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //            $(this).addClass("active");
    //            $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");
    //        }
    //    }
    //    if ($(window).width() < 991) {
    //        $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
    //        $(this).addClass("active");
    //        $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");
    //    }

    //});

    if (isMobile(false) && isAppleMobile() && !IsAndroid()) {

        $(".HomeSuggestPrdArea .TitleSuggest h3").css("margin-bottom", "10px");
    }

    if ($(".HomeProducts").length > 0) {

        //$("#HomeCatalogTabs .ProductList .Prd").removeClass("col-md-4");
        //$("#HomeCatalogTabs .ProductList .Prd").addClass("col-md-6");

        $(".HomeProducts div.Prd > a").each(function (index) {

            var imgBG = $(this).find("img:first").attr("src");

            if (imgBG.indexOf("404") != -1 && $(this).find("img:first").attr("data-qazy-src") != undefined) {
                imgBG = $(this).find("img:first").attr("data-qazy-src");
            }

            $(this).css("background-image", "url(" + imgBG + ")");
            $(this).parent().append("<a href='" + $(this).attr("href") + "' class='GotoDetails'>" + $("#GotoDetailsVl").val() + "</a>");

        });
    }

    if (!isMobile(true)) {

        $("#CatalogTabs > li").live({
            mouseenter:
                function () {

                    $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
                    $(this).addClass("active");



                    $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");

                },
            mouseleave:
                function () {


                }
        });

        if ($("#CatalogTabs li[data-id='173']").length > 0) {

            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $("#CatalogTabs > li").removeClass("active");

            $("#CatalogTabs li[data-id='173']").addClass("active");
            var index = $("#CatalogTabs li[data-id='173']").index();
            $("#HomeCatalogContens > div").eq(index).addClass("active");

        }


    }

    $("#CatalogTabs li").live("click", function () {

        var href = $("#MainMenu li a[data-rel='" + $("#CatalogTabs li.active").data("id") + "']").attr("href");


        if (!isMobile(true)) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        } else if ($(this).hasClass("active")) {

            if (href != undefined && href != null) {
                document.location.href = href;
            }

        }
        else {
            $("#CatalogTabs > li, #HomeCatalogContens > div").removeClass("active");
            $(this).addClass("active");
            $("#HomeCatalogContens > div").eq($(this).index()).addClass("active");
        }

    });


    function HometabSlider() {

        $("#HomeCatalogContens img.img2").remove();

        $("#HomeCatalogContens .HomeProducts.HomeTabItem .ProductList").slick({
            nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            useTransform: false,
        });

    }

    function HomeSuggestedPrdsSlider() {
        var valueSlidesToShow = 4;

        if ($(window).width() < 767) {
            valueSlidesToShow = 2;
        }
        $(".HomeSuggestPrdArea .ProductList").slick({
            nextArrow: '<div class="PrdHomeImgRight right-arrow"></div>',
            prevArrow: '<div class="PrdHomeImgLeft left-arrow"></div>',
            slidesToShow: valueSlidesToShow,
            slidesToScroll: 1,
            arrows: true,
            useTransform: false,
        });

    }

    $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").live("click", function () {

        var href = $(this).find(".middleText").find("a").first().attr("href");

        if (href != undefined && href != null) {

            document.location.href = href;
        }

    });


    if ($("#CookieNotificationArea").length > 0) {
        $("#CookieNotificationArea .CookieLink > #CookieCloseBtn").click(function () {

            $("#CookieNotificationArea").css("display", "none");
            $("footer #Legal").css("margin-bottom", "0px");
        });

        var cookieName = 'TrendTesetturCookie_Notif280518';
        var cookieValue = 'TrendTesetturCookie_val280518';

        if (typeof getCookie(cookieName) == "undefined") {
            $("#CookieNotificationArea").css("display", "block");

            setCookie(cookieName, cookieValue);
        }
    }
    //function GetLastVisitedProducts() {

    //    if ($(".AutoGetLastVisited").length > 0) {

    //        $.ajax({
    //            type: "GET",
    //            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProducts?SpecialTo=true",
    //            cache: false,
    //            success: function (dt) {

    //                $(".LastViewedProducts.AutoSetted").remove();

    //                if (dt != "") {

    //                    $(".AutoGetLastVisited").append(dt);

    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
    //                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
    //                    $(".LastViewedProducts .ProductList .Prd:gt(3)").addClass("hidden-sm");

    //                    if ($(".LastViewedProducts .ProductList .Prd").length >= 6) {
    //                        $(".AutoGetLastVisited").show();
    //                    }

    //                }

    //            }
    //        });
    //    }
    //}

    //GetLastVisitedProducts();

    //homebannerFull2


    $(".CareerTable #Phone2").live("click", function () {
        if ($(".CareerTable #Phone2").val() == '') {
            $(".CareerTable #Phone2").val('0');
        }
       
    });

});
function PhoneFormat() {

    $(".CareerTable #Phone2").mask("9999 999 99 99");
}
